const usePermissionConfig = () => {
  return {
    // SSO详情
    SSOXQ: 'OPS-XXZX-SSOZX-SSOXQ',
  };
};

export default usePermissionConfig;
